"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "addEvent", {
  enumerable: true,
  get: function get() {
    return _addEvent["default"];
  }
});
var _addEvent = _interopRequireDefault(require("./addEvent.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }